import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import { Row, Col, Skeleton } from 'antd';
import { styled } from '@xstyled/styled-components';
import { useMemo } from 'react';
import { QuestionReleases, QuestionType } from '@module/form';
import { PanelButton } from './pannel-button.component';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledPanelRowWrapper = styled(Row)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledAnswerItemColumn = styled(Col)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n"])), styleVariables.margin.small);
var StyledSectionTitle = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  margin: ", " 0 ", ";\n"])), styleVariables.font.fontSizeSupport, styleVariables.font.fontWeightStrong, styleVariables.margin.large, styleVariables.margin.medium);
var SectionSummaryPart = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 100%;\n  overflow-y: auto;\n"])));
export var SummaryPanel = function SummaryPanel(props) {
  var label = props.label,
      sectionSummaries = props.sectionSummaries,
      onSelectSection = props.onSelectSection,
      onSelectQuestion = props.onSelectQuestion,
      questionReleases = props.questionReleases,
      disable = props.disable,
      answers = props.answers,
      isSubmissionSubmitted = props.isSubmissionSubmitted;
  var panelButtonLabels = {
    correctAnswerQuestion: label.correctAnswerQuestion,
    wrongAnswer: label.wrongAnswer,
    graded: label.graded,
    awaitingGrading: label.awaitingGrading,
    skipped: label.skipped,
    customGrade: label.customGrade,
    essayQuestion: label.essayQuestion
  };
  var continuousQuestionIndexes = useMemo(function () {
    return QuestionReleases.getContinuousQuestionIndexes(questionReleases, sectionSummaries);
  }, [questionReleases, sectionSummaries]);

  var getQuestionDisplayIndex = function getQuestionDisplayIndex(question) {
    var _ref, _continuousQuestionIn;

    return (_ref = (_continuousQuestionIn = continuousQuestionIndexes.get(question.id.toString())) !== null && _continuousQuestionIn !== void 0 ? _continuousQuestionIn : question.index) !== null && _ref !== void 0 ? _ref : 1;
  };

  var sortedSectionSummaries = useMemo(function () {
    return sectionSummaries !== null && sectionSummaries !== void 0 ? sectionSummaries : [];
  }, [sectionSummaries]);
  var renderPanels = sortedSectionSummaries.map(function (section, index) {
    var isQuestionsOrAnswersLoading = !questionReleases || !answers;
    var questionsBySection = questionReleases === null || questionReleases === void 0 ? void 0 : questionReleases.filter(function (q) {
      var _q$sectionId;

      return ((_q$sectionId = q.sectionId) === null || _q$sectionId === void 0 ? void 0 : _q$sectionId.toString()) === section.id.toString();
    }).slice().sort(function (a, b) {
      var _ref2, _continuousQuestionIn2, _ref3, _continuousQuestionIn3;

      return ((_ref2 = (_continuousQuestionIn2 = continuousQuestionIndexes.get(a.id.toString())) !== null && _continuousQuestionIn2 !== void 0 ? _continuousQuestionIn2 : a.index) !== null && _ref2 !== void 0 ? _ref2 : 0) - ((_ref3 = (_continuousQuestionIn3 = continuousQuestionIndexes.get(b.id.toString())) !== null && _continuousQuestionIn3 !== void 0 ? _continuousQuestionIn3 : b.index) !== null && _ref3 !== void 0 ? _ref3 : 0);
    });
    var renderItem = isQuestionsOrAnswersLoading ? /*#__PURE__*/_jsx(Col, {
      span: 24,
      children: /*#__PURE__*/_jsx(Skeleton, {
        active: true,
        paragraph: {
          rows: 2
        },
        title: false
      })
    }) : questionsBySection === null || questionsBySection === void 0 ? void 0 : questionsBySection.map(function (q) {
      var answer = answers === null || answers === void 0 ? void 0 : answers.find(function (a) {
        return a.questionId === q.id.toString();
      });
      var questionDisplayIndex = getQuestionDisplayIndex(q);

      switch (q.type) {
        case QuestionType.FillInBlank:
          {
            var _fillInBlankAnswer$an;

            var fillInBlankQuestion = q;
            var fillInBlankAnswer = answer; // Nếu không có answer và submission đã nộp, hiển thị skipped cho tất cả blanks

            if (!fillInBlankAnswer && isSubmissionSubmitted) {
              var _q$answers;

              return (_q$answers = q.answers) === null || _q$answers === void 0 ? void 0 : _q$answers.map(function (_, blankIndex) {
                return /*#__PURE__*/_jsx(StyledAnswerItemColumn, {
                  children: /*#__PURE__*/_jsx(PanelButton, {
                    isSkipped: true,
                    hasAnswer: false,
                    onClick: function onClick() {
                      onSelectQuestion && onSelectQuestion(q.id.toString());
                      onSelectSection && onSelectSection(section.id.toString());
                    },
                    disabled: disable,
                    questionIndex: blankIndex + questionDisplayIndex,
                    label: panelButtonLabels
                  })
                }, "".concat(q.id.toString(), "-").concat(blankIndex));
              });
            }

            return fillInBlankAnswer === null || fillInBlankAnswer === void 0 ? void 0 : (_fillInBlankAnswer$an = fillInBlankAnswer.answers) === null || _fillInBlankAnswer$an === void 0 ? void 0 : _fillInBlankAnswer$an.map(function (fillInBlankAnswerItem, blankIndex) {
              var _fillInBlankAnswerIte;

              var isCorrect = fillInBlankQuestion.isCorrect(fillInBlankAnswerItem.answerBlankId, (_fillInBlankAnswerIte = fillInBlankAnswerItem.value) === null || _fillInBlankAnswerIte === void 0 ? void 0 : _fillInBlankAnswerIte.text);
              var hasAnswer = fillInBlankAnswerItem && !fillInBlankAnswerItem.isSkipped();
              var isSkipped = isSubmissionSubmitted && !hasAnswer;
              return /*#__PURE__*/_jsx(StyledAnswerItemColumn, {
                children: /*#__PURE__*/_jsx(PanelButton, {
                  isSkipped: isSkipped,
                  hasAnswer: hasAnswer,
                  isCorrect: hasAnswer ? isCorrect : undefined,
                  score: fillInBlankAnswerItem === null || fillInBlankAnswerItem === void 0 ? void 0 : fillInBlankAnswerItem.score,
                  hasGraded: fillInBlankAnswerItem === null || fillInBlankAnswerItem === void 0 ? void 0 : fillInBlankAnswerItem.hasGraded(),
                  onClick: function onClick() {
                    onSelectQuestion && onSelectQuestion(q.id.toString());
                    onSelectSection && onSelectSection(section.id.toString());
                  },
                  disabled: disable,
                  questionIndex: blankIndex + questionDisplayIndex,
                  label: panelButtonLabels
                })
              }, "".concat(q.id.toString(), "-").concat(blankIndex));
            });
          }

        case QuestionType.Matching:
          {
            var _matchingAnswerGroup$;

            var matchingQuestion = q;
            var matchingAnswerGroup = answer; // Nếu không có answer và submission đã nộp, hiển thị skipped cho tất cả sub-questions

            if (!matchingAnswerGroup && isSubmissionSubmitted) {
              var _matchingQuestion$sub;

              return (_matchingQuestion$sub = matchingQuestion.subQuestions) === null || _matchingQuestion$sub === void 0 ? void 0 : _matchingQuestion$sub.map(function (_, subIndex) {
                return /*#__PURE__*/_jsx(StyledAnswerItemColumn, {
                  children: /*#__PURE__*/_jsx(PanelButton, {
                    isSkipped: true,
                    hasAnswer: false,
                    onClick: function onClick() {
                      onSelectQuestion && onSelectQuestion(q.id.toString());
                      onSelectSection && onSelectSection(section.id.toString());
                    },
                    disabled: disable,
                    questionIndex: subIndex + questionDisplayIndex,
                    label: panelButtonLabels
                  })
                }, "".concat(q.id.toString(), "-").concat(subIndex));
              });
            }

            return matchingAnswerGroup === null || matchingAnswerGroup === void 0 ? void 0 : (_matchingAnswerGroup$ = matchingAnswerGroup.answers) === null || _matchingAnswerGroup$ === void 0 ? void 0 : _matchingAnswerGroup$.map(function (matchingAnswer, subIndex) {
              var _matchingAnswer$value;

              var isCorrect = matchingQuestion.isCorrect(matchingAnswer.subQuestionId, (_matchingAnswer$value = matchingAnswer.value) === null || _matchingAnswer$value === void 0 ? void 0 : _matchingAnswer$value.answerId);
              var hasAnswer = matchingAnswer && !matchingAnswer.isSkipped();
              var isSkipped = isSubmissionSubmitted && !hasAnswer;
              return /*#__PURE__*/_jsx(StyledAnswerItemColumn, {
                children: /*#__PURE__*/_jsx(PanelButton, {
                  isSkipped: isSkipped,
                  hasAnswer: hasAnswer,
                  isCorrect: hasAnswer ? isCorrect : undefined,
                  score: matchingAnswer === null || matchingAnswer === void 0 ? void 0 : matchingAnswer.score,
                  hasGraded: matchingAnswer === null || matchingAnswer === void 0 ? void 0 : matchingAnswer.hasGraded(),
                  onClick: function onClick() {
                    onSelectQuestion && onSelectQuestion(q.id.toString());
                    onSelectSection && onSelectSection(section.id.toString());
                  },
                  disabled: disable,
                  questionIndex: subIndex + questionDisplayIndex,
                  label: panelButtonLabels
                })
              }, "".concat(q.id.toString(), "-").concat(subIndex));
            });
          }

        case QuestionType.Essay:
          {
            var essayAnswerGroup = answer;
            return /*#__PURE__*/_jsx(StyledAnswerItemColumn, {
              children: /*#__PURE__*/_jsx(PanelButton, {
                active: essayAnswerGroup === null || essayAnswerGroup === void 0 ? void 0 : essayAnswerGroup.hasGraded(),
                onClick: function onClick() {
                  onSelectQuestion && onSelectQuestion(q.id.toString());
                  onSelectSection && onSelectSection(section.id.toString());
                },
                disabled: disable,
                questionIndex: questionDisplayIndex,
                label: panelButtonLabels
              })
            }, q.id.toString());
          }

        case QuestionType.SingleChoice:
          {
            var _singleChoiceAnswer$v;

            var singleChoiceQuestion = q;
            var singleChoiceAnswer = answer; // Nếu không có answer, hasAnswer = false

            var hasAnswer = singleChoiceAnswer && !singleChoiceAnswer.isSkipped(); // Nếu submission đã nộp và không có answer -> skipped

            var isSkipped = isSubmissionSubmitted && !hasAnswer; // Chỉ check isCorrect khi có answer

            var isCorrect = hasAnswer ? singleChoiceQuestion.isCorrect(singleChoiceAnswer === null || singleChoiceAnswer === void 0 ? void 0 : (_singleChoiceAnswer$v = singleChoiceAnswer.value) === null || _singleChoiceAnswer$v === void 0 ? void 0 : _singleChoiceAnswer$v.answerId) : undefined;
            return /*#__PURE__*/_jsx(StyledAnswerItemColumn, {
              children: /*#__PURE__*/_jsx(PanelButton, {
                isSkipped: isSkipped,
                hasAnswer: hasAnswer,
                isCorrect: isCorrect,
                score: singleChoiceAnswer === null || singleChoiceAnswer === void 0 ? void 0 : singleChoiceAnswer.score,
                hasGraded: singleChoiceAnswer === null || singleChoiceAnswer === void 0 ? void 0 : singleChoiceAnswer.hasGraded(),
                onClick: function onClick() {
                  onSelectQuestion && onSelectQuestion(q.id.toString());
                  onSelectSection && onSelectSection(section.id.toString());
                },
                disabled: disable,
                questionIndex: questionDisplayIndex,
                label: panelButtonLabels
              })
            }, q.id.toString());
          }

        case QuestionType.MultipleChoice:
          {
            var _multipleChoiceAnswer;

            var multipleChoiceQuestion = q;
            var multipleChoiceAnswer = answer; // Nếu không có answer, hasAnswer = false

            var _hasAnswer = multipleChoiceAnswer && !multipleChoiceAnswer.isSkipped(); // Nếu submission đã nộp và không có answer -> skipped


            var _isSkipped = isSubmissionSubmitted && !_hasAnswer; // Chỉ check isCorrect khi có answer


            var _isCorrect = _hasAnswer ? multipleChoiceQuestion.isCorrect((multipleChoiceAnswer === null || multipleChoiceAnswer === void 0 ? void 0 : (_multipleChoiceAnswer = multipleChoiceAnswer.values) === null || _multipleChoiceAnswer === void 0 ? void 0 : _multipleChoiceAnswer.map(function (v) {
              return v.answerId;
            })) || []) : undefined;

            return /*#__PURE__*/_jsx(StyledAnswerItemColumn, {
              children: /*#__PURE__*/_jsx(PanelButton, {
                isSkipped: _isSkipped,
                hasAnswer: _hasAnswer,
                isCorrect: _isCorrect,
                score: multipleChoiceAnswer === null || multipleChoiceAnswer === void 0 ? void 0 : multipleChoiceAnswer.score,
                hasGraded: multipleChoiceAnswer === null || multipleChoiceAnswer === void 0 ? void 0 : multipleChoiceAnswer.hasGraded(),
                onClick: function onClick() {
                  onSelectQuestion && onSelectQuestion(q.id.toString());
                  onSelectSection && onSelectSection(section.id.toString());
                },
                disabled: disable,
                questionIndex: questionDisplayIndex,
                label: panelButtonLabels
              })
            }, q.id.toString());
          }

        default:
          {
            return /*#__PURE__*/_jsx(StyledAnswerItemColumn, {
              children: /*#__PURE__*/_jsx(PanelButton, {
                onClick: function onClick() {
                  onSelectQuestion && onSelectQuestion(q.id.toString());
                  onSelectSection && onSelectSection(section.id.toString());
                },
                disabled: disable,
                questionIndex: questionDisplayIndex,
                label: panelButtonLabels
              })
            }, q.id.toString());
          }
      }
    });
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(StyledSectionTitle, {
        children: "".concat(label.section, " ").concat(index + 1)
      }), /*#__PURE__*/_jsx(StyledPanelRowWrapper, {
        gutter: 8,
        children: renderItem
      })]
    }, section.id.toString());
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: !sectionSummaries ? /*#__PURE__*/_jsx(Skeleton, {
      active: true,
      paragraph: {
        rows: 10
      }
    }) : /*#__PURE__*/_jsx(SectionSummaryPart, {
      children: renderPanels
    })
  });
};